/**
 * MINI Lander page interactions (template: page.mini-lander-dbmini)
 */
(function () {
  'use strict';

  function init() {
    if (!document.body.classList.contains('mini-lander-page')) return;

    var root = document;

    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mini-lander-reveal--visible');
            revealObserver.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    root.querySelectorAll('.mini-lander-reveal').forEach(function (el) {
      revealObserver.observe(el);
    });

    var viz = root.getElementById('mini-lander-sound-viz');
    if (viz) {
      var heights = [30, 50, 70, 90, 100, 80, 60, 100, 90, 70, 55, 80, 100, 65, 40, 60, 85, 100, 75, 50];
      heights.forEach(function (h, i) {
        var bar = document.createElement('div');
        bar.className = 'mini-lander-sound-bar';
        bar.style.height = h + '%';
        bar.style.animationDelay = i * 0.07 + 's';
        bar.style.animationDuration = 1.2 + (i % 4) * 0.15 + 's';
        viz.appendChild(bar);
      });
    }

    root.querySelectorAll('.mini-lander-faq-item').forEach(function (item) {
      var q = item.querySelector('.mini-lander-faq-question');
      if (!q) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('mini-lander-faq-item--open');
        root.querySelectorAll('.mini-lander-faq-item.mini-lander-faq-item--open').forEach(function (o) {
          o.classList.remove('mini-lander-faq-item--open');
        });
        if (!isOpen) item.classList.add('mini-lander-faq-item--open');
      });
    });

    function getFeaturedVariantPicker() {
      var wrap = root.querySelector('.shopify-section--featured-product');
      return wrap ? wrap.querySelector('variant-picker') : root.querySelector('variant-picker');
    }

    function getActiveOptionValueIds(form) {
      return Array.from(form.elements)
        .filter(function (el) {
          return el.matches && el.matches('input[data-option-position]:checked');
        })
        .sort(function (a, b) {
          return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10);
        })
        .map(function (el) {
          return el.value;
        });
    }

    function applyColorCardSelection(card) {
      root.querySelectorAll('.mini-lander-color-card').forEach(function (c) {
        c.classList.remove('mini-lander-color-card--active');
      });
      card.classList.add('mini-lander-color-card--active');

      var position = parseInt(card.getAttribute('data-option-position'), 10);
      var valueId = card.getAttribute('data-option-value-id');
      if (!position || !valueId) return;

      var picker = getFeaturedVariantPicker();
      if (!picker) return;

      var formId = picker.getAttribute('form-id');
      var form = formId ? document.getElementById(formId) : null;
      if (!form) return;

      var nextCombo = getActiveOptionValueIds(form);
      var idx = position - 1;
      if (nextCombo.length === 0) {
        nextCombo = [valueId];
      } else if (idx >= 0 && idx < nextCombo.length) {
        nextCombo[idx] = valueId;
      } else {
        return;
      }

      if (typeof picker.selectCombination === 'function') {
        picker.selectCombination({ optionValues: nextCombo, productChange: false });
      } else {
        var input = form.querySelector(
          'input[data-option-position="' + position + '"][value="' + String(valueId) + '"]'
        );
        if (input && !input.disabled) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      var colorsSection = card.closest('.mini-lander-colors');
      if (colorsSection && colorsSection.getAttribute('data-scroll-to-buy') === 'true') {
        var buy = root.getElementById('mini-lander-buy');
        if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    root.querySelectorAll('.mini-lander-color-card').forEach(function (card) {
      card.addEventListener('click', function () {
        applyColorCardSelection(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          applyColorCardSelection(card);
        }
      });
    });

    root.querySelectorAll('.mini-lander-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        root.querySelectorAll('.mini-lander-swatch').forEach(function (s) {
          s.classList.remove('mini-lander-swatch--active');
        });
        sw.classList.add('mini-lander-swatch--active');
        var label = root.getElementById('mini-lander-selected-color');
        if (label && sw.dataset.color) label.textContent = 'Selected: ' + sw.dataset.color;
      });
    });

    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (!id || id === '#') return;
        var target = root.querySelector(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
